<div class="details-container" *ngIf="booking" role="main">
  <div class="row no-gutters mb-3">
    <div class="col">
      <app-arrow-link-left
        text="Back"
        (click)="goBack()"
        (keyup.enter)="goBack()"
      ></app-arrow-link-left>
    </div>
  </div>
  <div *ngIf="booking.status === 10" class="row no-gutters">
    <div class="col">
      <div class="error-box p-15 text-center">
        <img
          height="24"
          width="24"
          src="../../assets/svg/ico_error_circle.svg"
        />
        <p class="error-box-text">
          {{booking.declineReason}}
        </p>
      </div>
    </div>
  </div>

  <div class="row no-gutters">
    <div class="col">
      <span
        class="status lato bold"
        [ngClass]="{
          waitlist: booking.status === 0,
          confirmed: booking.status === 1,
          checkedIn: booking.status === 2,
          pending: booking.status === 9,
          declined: booking.status === 10
        }"
      >
        {{ booking.statusTypeTextUI }}</span
      >
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col">
      <span
        *ngIf="booking.status === 1 || booking.status === 10 || booking.isInterviewRequest === false"
        style="font-size: 12"
        >{{
          booking.startDate === booking.endDate
            ? (booking.startDate | date)
            : (booking.startDate | date) + " - " + (booking.endDate | date)
        }}</span>
      <span *ngIf="booking.status === 9 && booking.isInterviewRequest === true">
        CBW staff will contact you shortly</span
      >
      <!-- <span *ngIf="booking.status === 10 && this.isInterviewRequest === true">
        Your request has been declined</span
      > -->
    </div>
  </div>
  <hr />
  <div class="row no-gutters">
    <div class="col">
      <h5 class="lato bold">
        {{ booking.bookingTitleUI }}
      </h5>
      <p class="lato bold pet-name">
        {{ booking.petNamesUI }}
      </p>
    </div>
  </div>
  <hr />
  <div class="row no-gutters">
    <div class="col">
      <span class="lato bold">
        {{ booking.franchise.name }} </span
      ><br />
      <span class="lato">
        {{ booking.addressUI}} </span
      ><br />
      <span class="lato">
        {{ booking.franchise.telephone | mask: "(000) 000-0000" }}
      </span>
    </div>
  </div>
  <div class="row no-gutters" *ngIf="displayCancel && booking.status !== 10">
    <div class="col">
      <div class="announce-container">
        <h1 class="title bold lato crimson" style="text-transform: uppercase">
          Change/Cancel My Reservation
        </h1>
        <p class="p lato text-left" style="padding: 10 0">
          To make a change or cancel this upcoming reservation, please call
          Camp.
        </p>
        <a [href]="'tel:' + booking.franchise.telephone">
          <button
            class="btn btn-outline-danger"
            style="background: #ffffff"
            (click)="callToCancel()"
          >
            Call {{ booking.franchise.telephone | mask: "(000) 000-0000" }}
          </button>
        </a>
      </div>
    </div>
  </div>
  <hr />
  <div class="row no-gutters">
    <div class="col service-table">
      <div>
        <div class="lato bold">Total Service Visit:</div>
      </div>
      <div *ngFor="let item of booking.items">
        <div class="lato">{{ getServiceTitle(item) }}</div>
        <!-- <div class="lato bold">{{(service.price | currency)}}</div> -->
      </div>
      <hr />
      <!-- <div class="">
        <div class="lato">Total:</div>
        <div class="lato bold">{{totalPrice | currency}}</div>
      </div> -->
    </div>
  </div>
</div>
